import usaj_ga from '../script/Analytics/usaj-analytics'
var myCounter = 5;
var closeTimer = 0;
var myDropDown = 0;
global.pathname = window.parent.document.location.pathname;
global.hostName = window.location.host;
global.protocol = window.parent.document.location.protocol;

var Browser = {
    Version: function () {
        var version = 999; // we assume a sane browser
        if (navigator.appVersion.indexOf("MSIE") != -1)
            // bah, IE again, lets downgrade version number
            version = parseFloat(navigator.appVersion.split("MSIE")[1]);
        return version;
    }
};

global.throttleTimer = false;
global.throttle = (time, callback) => {
    if (throttleTimer) return;
    throttleTimer = true;
    setTimeout(() => {
        callback();
        throttleTimer = false;
    }, time);
}

$(function () {
    document.querySelectorAll('h1').forEach(h => {
        if (!h.getAttribute('tabindex')) {
            h.setAttribute('tabindex', "-1");
        }
    });

    $("#footer-back-to-top").click(evt => {
        evt.preventDefault();
        const focusable = document.querySelector('#body-content').querySelectorAll('button, [href], input:not([type="hidden"]), [tabindex="0"], [tabindex="-1"]');
        if (focusable && focusable.length > 0 && focusable[0].style.visibility != 'hidden') {
            focusable[0].focus();
        }
        else {
            document.querySelector('#top').focus();
            $(window).scrollTop($('.usajobs-nav__body').position().top);
        }
    });

    //Style error handling on input text divs
    $("div.required-input").has("span.field-validation-error").addClass('usa-input-error');
    if (typeof lis !== 'undefined' && lis) {
        if (typeof $.jobsIdleTimeout === 'function') {
            $.jobsIdleTimeout({
                redirAfter: mySessionTimeout,
                warnAfter: myInactivity,
                noconfirm: 480000
            });
        }
    };

    //This is a function added to JQuery fn object to fix stupid IE9 table display issues...
    //To fix a table call $("#TableID").htmlClean();
    jQuery.fn.htmlClean = function () {
        this.contents().filter(function () {
            if (this.nodeType != 3) {
                $(this).htmlClean();
                return false;
            }
            else {
                return !/\S/.test(this.nodeValue);
            }
        }).remove();
        return this;
    }

    //This is to fix an issue with MVC3 Html.TextAreas and the AntiXss library
    $("textarea").each(function () { $(this).val(jQuery.trim($(this).val())); });

    //2493 Skip Link code
    $('#homeSkip').click(function () {
        $('#Keyword').focus();
    });
    //2493 Skip Link code
    $('#footerSkip').click(function () {
        $('#footer a:first').focus();
    });
    //2493 esc to disable top menu
    var $link = $("#topmenu ul li a");
    var $linkHasFocus = false;

    $link.focus(function () {
        $linkHasFocus = true;
    }).blur(function () {
        $linkHasFocus = false;
    });

    $(document).keyup(function (event) {
        if (event.keyCode == 27) {
            if ($linkHasFocus == true) {
                if ($link.next(":visible").prev().get(0)) {
                    $link.next(":visible").prev().get(0).focus();
                    $link.next(":visible").slideUp("fast");
                }
            }
        }
    });

    //3077 USAJOBS Social Buttons hover effect
    $('#followusajobs a.youtube img').mouseover(function () {
        $('#followusajobs a.youtube img').attr("src", "/Content/images/png/YouTube_hover.png");
    }).mouseout(function () {
        $('#followusajobs a.youtube img').attr("src", "/Content/images/png/YouTube_nohover.png");
    });

    $('#followusajobs a.twitter img').mouseover(function () {
        $('#followusajobs a.twitter img').attr("src", "/Content/images/png/twitter_hover.png");
    }).mouseout(function () {
        $('#followusajobs a.twitter img').attr("src", "/Content/images/png/twitter_nohover.png");
    });

    $('#followusajobs a.facebook img').mouseover(function () {
        $('#followusajobs a.facebook img').attr("src", "/Content/images/png/facebook_hover.png");
    }).mouseout(function () {
        $('#followusajobs a.facebook img').attr("src", "/Content/images/png/facebook_nohover.png");
    });

    $('#btnPause').mouseover(function () {
        $('#btnPause').attr("src", "/Content/images/png/Pause-MouseOn.png");
    }).mouseout(function () {
        $('#btnPause').attr("src", "/Content/images/png/Pause-MouseOff.png");
    });

    $('#btnPlay').mouseover(function () {
        $('#btnPlay').attr("src", "/Content/images/png/Play-MouseOn.png");
    }).mouseout(function () {
        $('#btnPlay').attr("src", "/Content/images/png/Play-MouseOff.png");
    });


    $("#menu li a[href$='" + pathname + "']").parent("li").parent("ul").prev().addClass("current");
    if (pathname == '/' ||
        pathname == '/Home/Support') {
        $("#menu ul > li:first > a").addClass("current");
        $("#menu ul.dropdown > li:first > a").removeClass("current");
    }
    if (pathname == '/Search' ||
        pathname == '/Search/GetAdvancedResults') {
        $("#menu ul.dropdown > li:first > a").addClass("current");
    }
    if (pathname == '/Account/Login' ||
        pathname == '/Applicant/Profile/HiringEligibilityData' ||
        pathname == '/Applicant/Profile/Preferences' ||
        pathname == '/Applicant/Profile/DemographicData' ||
        pathname == '/Applicant/Profile/AccountInformation' ||
        pathname == '/Applicant/Resume/WorkExperience' ||
        pathname == '/Applicant/Resume/Education' ||
        pathname == '/Applicant/Resume/OtherQualifications' ||
        pathname == '/Applicant/Resume/References' ||
        pathname == '/Applicant/Resume/PreviewAndFinish') {
        $("#myAcctLink").addClass("current");
    }

    $("#passwordexpireclose").click(function () {
        $("div#passwordexpirepanel").slideUp("slow", function () {
            $("#toppanel").css("z-index", "1");
        });
        $("div#passwordexpirepanel").css("margin-top", "-8px");
        $("#passwordexpiring").css("display", "block");
        $("#passwordexpireclose").css('display', 'none');
        $("#passwordexpireopen").css('display', 'block');
    });

    $("#passwordexpireopen").click(function () {
        $("div.tab").css("display", "block");
        $("div#passwordexpirepanel").slideDown("slow");
        $("#toppanel").css("z-index", "999");
        $("#passwordexpireclose").css('display', 'block');
        $("#passwordexpireopen").css('display', 'none');
    });

    $('#usajobs-search-form form').submit(function (e) {
        var $keywordInput = $('.usajobs-nav__search-keywords-input');
        var $locationInput = $('.usajobs-nav__search-location-input');

        if ($('#IgnoreFormSubmit').length == 0) {
            if ($keywordInput.val() == "" && $locationInput.val() == "") {
                window.location.href = "/Search/Results";
                return false;
            } else if ($keywordInput.val() == "") {
                $keywordInput.attr('name', '');
            } else if ($locationInput.val() == "") {
                $locationInput.attr('name', '');
            }
        }
    });
});


global.ResumePrint = () => {
    var contents = $(".printme").html();
    var printFrame = $('<iframe />');
    printFrame[0].name = "printFrame";
    printFrame.css({ "position": "absolute", "top": "-1000000px" });
    $("body").append(printFrame);
    var frameDoc = printFrame[0].contentWindow ? printFrame[0].contentWindow : printFrame[0].contentDocument.document ? printFrame[0].contentDocument.document : printFrame[0].contentDocument;
    frameDoc.document.open();
    frameDoc.document.write('<html><head><title>Print Resume</title>');
    frameDoc.document.write('<style>.table { font-size: 10px; }</style>');
    frameDoc.document.write('<style>.print-visible-mobile { display: none; }</style>');
    frameDoc.document.write('</head><body style="overflow-x:hidden;">');
    frameDoc.document.write(contents);
    frameDoc.document.write('</body></html>');
    frameDoc.document.close();
    setTimeout(function () {
        window.frames["printFrame"].focus();
        window.frames["printFrame"].print();
        printFrame.remove();
    }, 500);
    return false;
}

function GoTo(selObj) {
    for (i = 0; i < selObj.length; i++)
        if (selObj.options[i].selected)
            window.location.replace(selObj.options[i].value);
}

function formatCurrency(dataToFormat) {
    if (isNaN(dataToFormat)) {
        dataToFormat = 0;
    }
    dataToFormat = dataToFormat.toString().replace(/\$|\,/g, '');
    if (isNaN(dataToFormat))
        dataToFormat = "0";

    sign = (dataToFormat == (dataToFormat = Math.abs(dataToFormat)));
    dataToFormat = Math.floor(dataToFormat * 100 + 0.50000000001);
    cents = dataToFormat % 100;
    dataToFormat = Math.floor(dataToFormat / 100).toString();

    if (cents < 10)
        cents = "0" + cents;

    for (var i = 0; i < Math.floor((dataToFormat.length - (1 + i)) / 3); i++)
        dataToFormat = dataToFormat.substring(0, dataToFormat.length - (4 * i + 3)) + ',' +
            dataToFormat.substring(dataToFormat.length - (4 * i + 3));

    var result = (((sign) ? '' : '-') + '$' + dataToFormat + '.' + cents);
    document.write(result);
}

function checkIfEmpty(dataToWrite) {
    if (dataToWrite) {
        var result = dataToWrite + '<br/>';
        document.write(result);
    }
}

function checkIfEmptyDisplayHeader(dataToWrite, header) {
    if (dataToWrite) {
        var results = header + ':' + ' ' + dataToWrite + '<br/>';
        document.write(results);
    }
}

function checkIfEmptyDisplayHeaderEmail(dataToWrite, header) {
    var originalLength = dataToWrite.length;
    var emailArray = new Array();
    if (dataToWrite) {
        if (originalLength > 25) {
            var iterationCount = originalLength / 25;
            for (var i = 0; i < iterationCount + 1; i++) {
                emailArray[i] = dataToWrite.substring(0, 24);
                dataToWrite = dataToWrite.substring(24);
            }
            dataToWrite = "";
            for (var i = 0; i < emailArray.length; i++) {
                if (i == emailArray.length - 1) {
                    dataToWrite = dataToWrite + emailArray[i];
                }
                else {
                    dataToWrite = dataToWrite + emailArray[i] + '<br/>';
                }
            }
        }
        else {
            dataToWrite = dataToWrite + '<br />';
        }
        var results = header + ':' + ' ' + dataToWrite;
        document.write(results);
    }
}

function checkVacancy(dataToWrite) {
    if (dataToWrite > 2) {
        var results = dataToWrite + ' vacancies - ';
        document.write(results);
    }
    else {
        var results = dataToWrite + ' vacancy - ';
        document.write(results);
    }
}

function checkIfEmptyDisplaySection(dataToWrite, header) {
    if (dataToWrite) {
        var results = '<h3> ' + header + ':' + '</h3>';
        var results = results + '<p>' + dataToWrite + '</p>';
        document.write(results);
    }
}

function checkIfEmptyMainHeaders(dataToWrite, header) {
    if (dataToWrite) {
        var header = '<h3> ' + header + ':' + '</h3>';
        var data = '<span class="info">' + dataToWrite + '</span>';
        document.write(header + data);
    }

}

function displayOptionalAgencySubelement(data) {
    if (data) {
        var data = '<p><strong>Hiring Organization:</strong><span class="info">' + data;
        data = data + ' </span></p>';
        document.write(data);
    }
}

function setResPreviewHtml() {
    var vdUrlStr = protocol + '//' + hostName + '/Applicant/Resume/PreviewResume/';  //'<%: ResolveUrl("~/Resume/PreviewResume/")%>';
    jQuery.ajax({
        type: 'GET',
        dataType: 'html',
        url: vdUrlStr,
        async: false, //wait on the result to be returned...                    
        success: function (data) {
            $("#rpDialog").html(data);
            $("#rpDialog").dialog("open");
            $(".printResumePreview a").attr("href", "javascript:void( 0 )").click(
                function () {
                    $(".printme").print();
                    return (false);
                });
        },
        cache: false
    });
    return false;
}

function showMenu(id) {
    cancelTimedClose();
    if (myDropDown) {
        myDropDown.style.visibility = 'hidden';
    }
    myDropDown = document.getElementById(id);
    myDropDown.style.visibility = 'visible';
    myDropDown.style.left = 'auto';
    myDropDown.style.top = 'auto';
}

function hideMenu() {
    if (myDropDown) {
        myDropDown.style.visibility = 'hidden';
    }
}

function timedMenuClose() {
    closeTimer = window.setTimeout(hideMenu, myCounter);
}

function cancelTimedClose() {
    if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
    }
}

function updateStatus(newStatus) {
    var urlStr = protocol + '//' + hostName + '/Home/UpdateStatus';
    jQuery.ajax({
        type: 'GET',
        contentType: "html",
        data: { newStatus: newStatus },
        url: urlStr,
        async: false,
        cache: false
    });
}

var thisDocumentID;

function init() {
    $('#lblValidationError').hide();
    $('#lblNotify').hide();
    $('#ToAddress').val('');
    $("#btnSendEmail").show();
    $("#btnCancel").show();
    $("#btnFinish").hide();
}

function shareJobLink(documentID) {
    thisDocumentID = documentID;
    init();
    $('#shareMe').modal({ backdrop: 'static' });
    return false;
}

function isEmpty() {
    var toEmail = $('#ToAddress').val();
    if (!toEmail) {
        return true;
    }
    else {
        $('#lblValidationError').hide();
        return false;
    }
}

$(function () {
    $('li#sjLI').on('mouseover', function () {
        $('li#sjLI img.expandimage').attr("src", "/Content/images/gif/arrow-over.gif");
    });
    $('li#sjLI').on('mouseout', function () {
        $('li#sjLI img.expandimage').attr("src", "/Content/images/gif/arrow-off.gif");
    });
    $('li#maLI').on('mouseover', function () {
        $('li#maLI img.expandimage').attr("src", "/Content/images/gif/arrow-over.gif");
    });
    $('li#maLI').on('mouseout', function () {
        $('li#maLI img.expandimage').attr("src", "/Content/images/gif/arrow-off.gif");
    });
    $('li#rcLI').on('mouseover', function () {
        $('li#rcLI img.expandimage').attr("src", "/Content/images/gif/arrow-over.gif");
    });
    $('li#rcLI').on('mouseout', function () {
        $('li#rcLI img.expandimage').attr("src", "/Content/images/gif/arrow-off.gif");
    });
});

document.onclick = hideMenu;
window.onload = function () {
    $('<br /><img alt="required" src="' + protocol + '//' + hostName + '/img/gif/dot.gif' + '" />').insertBefore("label.required");
    //<%: ResolveUrl("~/Content/images/gif/dot.gif")%>
};

(function (history) {
    var pushState = history.pushState;
    history.pushState = function (state) {
        var returnObj = pushState.apply(history, arguments)
        if (typeof history.onpushstate == "function") {
            history.onpushstate({ state: state });
        }
        return returnObj;
    }
})(window.history);

window.onpopstate = history.onpushstate = function (e) {
    if (e.state) {
        if (usaj_ga) {
            usaj_ga.log_page_view(window.location.pathname + window.location.search);
        }
    }
}
